import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'viewCountFormat',
})
export class ViewCountFormatPipe implements PipeTransform {
    transform(value: number): string {
        if (typeof value !== 'number') {
            return value;
        }
        if (+value >= 1e9) {
            // If the +value is in the billions, display in "1B" format
            return (+value / 1e9).toFixed(1) + 'B';
        } else if (+value >= 1e6) {
            // If the +value is in the millions, display in "1M" format
            return (+value / 1e6).toFixed(1) + 'M';
        } else if (+value >= 1e3) {
            // If the +value is in the thousands, display in "1K" format
            return (+value / 1e3).toFixed(1) + 'K';
        } else {
            // For +values less than 1,000, display as is
            return value.toString();
        }
    }
}
